import React, {useCallback, useContext, useEffect, useState} from 'react';
import {setOptions, Popup, Button} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import {CKEditor} from '@ckeditor/ckeditor5-react';
import {BalloonEditor, Autosave, Essentials, GeneralHtmlSupport, HtmlComment, Paragraph} from 'ckeditor5';
import 'ckeditor5/ckeditor5.css';
import '../styles/dashboardThinking.css';
import LoadingAvatar from "../utils/LoadingAvatar";
import {NetworkContext} from "../utils/NetworkContext";

setOptions({
    theme: 'ios',
    themeVariant: 'light',
});
const CalcElapsed = (startedAt) => Math.max(0, Math.floor((Date.now() - startedAt) / 1000));

function DashboardThinking({locale, thinking, voice, avatar, broadcast, setToast, locked, width, Dialog}) {
    const {wsCall} = useContext(NetworkContext);
    const [elapsed, setElapsed] = useState(() => CalcElapsed(thinking ? thinking : Date.now()));
    const [text, setText] = useState(locale.dashboardThinking.a);

    const DialogClose = useCallback(() => {
        Dialog({view: 'close'});
    }, [Dialog]);

    const ButtonRefresh = () => {
        setToast({message: locale.dashboardThinking.i, color: 'info', display: 'bottom', duration: false});

        const message = {
            type: 'wss',
            path: 'conversation',
            action: 'get',
            data: {
                system: false,
                rewind: false,
                error: false
            }
        };
        wsCall(message);
    }

    const ButtonRewind = () => {
        setToast({message: locale.dashboardThinking.j, color: 'info', display: 'bottom', duration: false});

        const message = {
            type: 'wss',
            path: 'conversation',
            action: 'get',
            data: {
                system: false,
                rewind: true,
                error: false
            }
        };
        wsCall(message);
    }

    useEffect(() => {
        setElapsed(CalcElapsed(thinking));

        const interval = setInterval(() => {
            setElapsed(CalcElapsed(thinking));
        }, 1000);

        return () => clearInterval(interval);
    }, [thinking]);

    useEffect(() => {
        if (elapsed > 1) {
            setToast({message: elapsed + ' ' + locale.dashboardThinking.f, color: 'info', display: 'bottom', duration: false});
        }
        if (!broadcast && elapsed >= 30 && elapsed <= 180) {
            setText(locale.dashboardThinking.b);
        } else if (!broadcast && elapsed > 180 && elapsed <= 420) {
            setText(locale.dashboardThinking.c);
        } else if (!broadcast && elapsed > 420) {
            setText(locale.dashboardThinking.e);
        }
    }, [elapsed, broadcast, locale.dashboardThinking.b, locale.dashboardThinking.c, locale.dashboardThinking.e, locale.dashboardThinking.f]);

    return (
        <Popup className={width < 576 ? "cs-dashboard-thinking-popup cs-dashboard-thinking-popup-overlay-xs" : "cs-dashboard-thinking-popup cs-dashboard-thinking-popup-overlay"} display="center" scrollLock={false} closeOnOverlayClick={false} closeOnEsc={false} fullScreen={broadcast ? true : false} buttons={[]} isOpen={thinking || locked} onClose={DialogClose}>
            <LoadingAvatar
                avatar={avatar}
                voice={voice}
                configuration={null}
            />
            {!broadcast &&
                <div className="mbsc-button-group-justified cs-dashboard-thinking-buttons">
                    <Button className="cs-dashboard-thinking-button mbsc-bold mbsc-txt-muted" variant="flat" >
                        {locked? locale.dashboardThinking.k : text}
                    </Button>
                </div>
            }
            {broadcast &&
                <div className="mbsc-row cs-dashboard-thinking-main cs-dashboard-thinking-scroll">
                    <div className="mbsc-col cs-dashboard-thinking-editor">
                        <CKEditor
                            onReady={editor => {
                                editor.enableReadOnlyMode('editor-dashboard-thinking');
                            }}
                            editor={BalloonEditor}
                            data={broadcast}
                            disableWatchdog={true}
                            config={{
                                toolbar: {
                                    items: [],
                                    shouldNotGroupWhenFull: true
                                },
                                plugins: [
                                    Autosave,
                                    Essentials,
                                    GeneralHtmlSupport,
                                    HtmlComment,
                                    Paragraph
                                ],
                                htmlSupport: {
                                    allow: [
                                        {
                                            name: /^.*$/,
                                            styles: true,
                                            attributes: true,
                                            classes: true
                                        }
                                    ]
                                },
                                licenseKey: 'GPL',
                                ui: {
                                    poweredBy: {position:'inside', side:'right'}
                                }
                            }}
                        />
                    </div>
                </div>
            }
            {!broadcast && (locked || (elapsed >= 30)) &&
                <div className="mbsc-button-group-justified cs-dashboard-thinking-nav-buttons">
                    {elapsed >= 30 &&
                        <Button color="primary" variant="flat" className="mbsc-bold cs-dashboard-thinking-nav-button" onClick={() => ButtonRefresh()} >
                            {locale.dashboardThinking.g}
                        </Button>
                    }
                    {locked &&
                        <Button color="primary" variant="flat" className="mbsc-bold cs-dashboard-thinking-nav-button" onClick={() => ButtonRewind()} >
                            {locale.dashboardThinking.h}
                        </Button>
                    }
                </div>
            }
        </Popup>
    );
}

export default DashboardThinking;
